import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { GET_NETWORKS } from 'redux/actions/networks';

const initialState = {
  isLoading: false,
  networks: [],
};

export const initialNetworksReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NETWORKS.STARTED:
      return { ...state, isLoading: true };
    case GET_NETWORKS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        networks: action.payload,
      };
    case GET_NETWORKS.FAIL:
      return { ...state, isLoading: false };

    default:
      return state;
  }
};

const persistConfig = {
  key: 'networks',
  storage: storage,
};

export const networksReducer = persistReducer(persistConfig, initialNetworksReducer);
